export enum ChipListCustomErrorEnum {
  invalid,
  exists,
}
